var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9099_3682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 8.49998L7 10.5L11 6.49998M14.6667 8.49998C14.6667 12.1819 11.6819 15.1666 8 15.1666C4.3181 15.1666 1.33333 12.1819 1.33333 8.49998C1.33333 4.81808 4.3181 1.83331 8 1.83331C11.6819 1.83331 14.6667 4.81808 14.6667 8.49998Z",
    stroke: "#079455",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9099_3682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputCheck);
export default __webpack_public_path__ + "static/media/input-check.e8cd060fad72ca3c4e28829808c34d25.svg";
export { ForwardRef as ReactComponent };